import { TextElement } from "./TextElement";
import { Subject } from "rxjs";

export abstract class TextManager {

    public addedText: Subject<TextElement> ;
    public removedText: Subject<TextElement>;

    private texts: {
        text: TextElement,
        lifetime: number,
        timeCreated: number
    }[];

    constructor() {
        this.texts = [];

        this.addedText = new Subject();
        this.removedText = new Subject();
    }

    public abstract createTextElement(text: string, lifetime?: number): TextElement;

    public addText(element: TextElement, lifetime?: number) {
        this.texts.push({
            text: element,
            lifetime: lifetime || 0,
            timeCreated: new Date().getTime()
        });

        this.addedText.next(element);
    }

    public removeText(element: TextElement) {
        let idx = this.texts.findIndex(obj => obj.text == element);

        if (idx != -1) {
            this.texts.splice(idx, 1);

            this.removedText.next(element);
        }
    }

    public iterate(callback: (e: TextElement) => void): void {
        let now = new Date().getTime();
        for (let i = this.texts.length - 1; i >= 0; i--) {
            let text = this.texts[i];

            // TODO: filter texts where !inWorldSpace (i.e. the text has a fixed onscreen position), works only for BrowserText

            if (text.lifetime) {
                if (text.timeCreated + text.lifetime > now) {
                    callback(text.text);
                } else {
                    this.texts.splice(i, 1);
                    text.text.destroy();
                }
            } else {
                callback(text.text);
            }
        }
    }
}
